export default __webpack_public_path__ + "static/media/geany.d81d4745.webp";